import { FILE_API_BASE_URL } from '../../../config/runtimeConfig';

const dateFormatter = new Intl.DateTimeFormat('ru-RU', { day: 'numeric', month: 'short', year: 'numeric' });
const moneyFormatter = new Intl.NumberFormat('ru-RU', { style: 'currency', currency: 'RUB' });

export function catalogImageUrl(fileId: number): string {
  const url = new URL(`/v1/catalog-view/images/${fileId}`, FILE_API_BASE_URL);
  return url.toString();
}

export function catalogDate(value: string): string {
  const date = new Date(value);
  const timestamp = date.getTime();
  return Number.isNaN(timestamp) ? 'Не указана' : dateFormatter.format(date);
}

export function catalogPrice(value: number): string {
  return moneyFormatter.format(value);
}

export function catalogQuantity(value: number): string {
  const quantity = Number(value);
  return quantity.toLocaleString('ru-RU', { maximumFractionDigits: 3 });
}
